import { tryParseJSONObject } from "@/utils";

function getLocalStorage(key, initialValue) {
  if (typeof window === "undefined") {
    return initialValue;
  }
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  try {
    // Get from local storage by key
    const item = window.localStorage.getItem(key);
    // Parse stored json or if none return initialValue
    const itemParse = tryParseJSONObject(item);
    if (!item) {
      return initialValue;
    }
    if (!itemParse) {
      return item;
    }
    return itemParse;
  } catch (error) {
    // If error also return initialValue
    console.log(error);
    return initialValue;
  }
}
export default getLocalStorage;
